import { usePeriod } from '../contexts/PeriodContext';
import { formatPeriodLabel } from '../utils/formatPeriodLabel';

export default function PeriodSelector() {
  const { periods, selectedPeriod, setSelectedPeriod, loading } = usePeriod();

  if (loading) {
    return (
      <div className="flex items-center gap-3">
        <label htmlFor="period-selector" className="text-sm text-foreground">Period:</label>
        <div className="px-3 py-1.5 text-sm text-muted-foreground bg-secondary rounded-md border border-border">
          Loading periods...
        </div>
      </div>
    );
  }

  if (periods.length === 0) {
    return (
      <div className="flex items-center gap-3">
        <label htmlFor="period-selector" className="text-sm text-foreground">Period:</label>
        <div className="px-3 py-1.5 text-sm text-muted-foreground bg-secondary rounded-md border border-border">
          No periods available
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <label htmlFor="period-selector" className="text-sm text-foreground">Period:</label>
      <select
        id="period-selector"
        value={selectedPeriod}
        onChange={(e) => setSelectedPeriod(e.target.value)}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all border cursor-pointer ${
          selectedPeriod
            ? 'bg-white text-black border-warning shadow-lg shadow-warning/50'
            : 'bg-secondary text-foreground border-border hover:bg-accent hover:border-warning hover:text-warning hover:shadow-lg hover:shadow-warning/50'
        } focus:outline-none focus:ring-2 focus:ring-warning focus:border-warning`}
        style={{
          appearance: 'none',
          backgroundImage: selectedPeriod
            ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23000' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`
            : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%239ca3af' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 0.75rem center',
          paddingRight: '2.5rem'
        }}
      >
        {periods.map(period => (
          <option key={period} value={period} className="bg-card text-foreground">
            {formatPeriodLabel(period)}
          </option>
        ))}
      </select>
    </div>
  );
}

